import React from 'react';
import type { SortConfig } from '../components/DataTable';

export interface BaseQueryParams {
  type: string;
  pageSize: number;
  [key: string]: any;
}

export interface SortQueryParams {
  OrderType: 'Asc' | 'Desc';
  OrderColumn: string;
}

export const createQueryParams = <T extends BaseQueryParams>(
  baseParams: T,
  sortConfig?: SortConfig,
  additionalParams?: Record<string, any>,
  defaultSortColumn: string = 'Rank'
): T & SortQueryParams => {
  const params = {
    ...baseParams,
    ...additionalParams,
  };

  let orderType: 'Asc' | 'Desc';
  let orderColumn: string;

  if (sortConfig?.order === 'default') {
    orderType = 'Asc';
    orderColumn = defaultSortColumn;
  } else if (sortConfig) {
    orderType = sortConfig.order === 'asc' ? 'Asc' : 'Desc';
    orderColumn = sortConfig.column;
  } else {
    orderType = 'Asc';
    orderColumn = defaultSortColumn;
  }

  return {
    ...params,
    OrderType: orderType,
    OrderColumn: orderColumn,
  };
};

export const useQueryParams = <T extends BaseQueryParams>(
  baseParams: T,
  sortConfig?: SortConfig,
  additionalParams?: Record<string, any>,
  defaultSortColumn: string = 'Rank'
) => {
  return React.useMemo(
    () => createQueryParams(baseParams, sortConfig, additionalParams, defaultSortColumn),
    [baseParams, sortConfig, additionalParams, defaultSortColumn]
  );
};
